export default {"src":"/_next/static/media/Tab logo.a9e3a308.svg","height":580,"width":478,"blurWidth":0,"blurHeight":0};